export default __webpack_public_path__ + "static/media/avatar_48.8dff8e87.png";